<template>
  <div :id="uniqueId" class="collection-case p-3">
    <b-row align-h="between" align-v="center">
      <b-col class="col-2" md="1" :class="[isMobile ? ['col-3', 'm-2'] : '']">
        <b-link class="collection-thumb-link" :href="collectionCase.links.showUrl">
          <b-aspect>
            <thumbnail-svg :thumbnail="keyImage" :size="400" :href="collectionCase.links.showUrl"></thumbnail-svg>
          </b-aspect>
        </b-link>
      </b-col>
      <b-col class="col">
        <b-link class="collection-title-link" :href="collectionCase.links.showUrl">
          <h5>{{ collectionCase.title }}</h5>
        </b-link>
        <span class="section">{{ collectionCase.subSpecialtySection.label }}</span>
      </b-col>
      <b-col class="settings col">
        <div class="justify-content-end d-flex">
          <dicom-viewer-button
            v-if="!isMobile"
            variant="outline-primary"
            class="mr-2"
            :studies="collectionCase.studies"
            :collection-case="collectionCase"
          >
          </dicom-viewer-button>
          <collection-item-actions
            tooltip-title="settings"
            class="mr-2"
            :resource="collectionCase"
            :can-remove-cases="canRemoveCases"
            :collection-id="collectionId"
            @removeCase="onRemoveCase"
          >
          </collection-item-actions>
          <btn
            v-slot="dropDownIcon"
            v-b-tooltip.hover
            fab
            icon
            icon-name="fa-angle-right"
            size="lg"
            variant="primary"
            :href="collectionCase.links.showUrl"
            :title="$t('cmrad.visit_case')"
          ></btn>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ThumbnailSvg from '@/Organisms/ThumbnailSvg';
  import CollectionItemActions from './CollectionItemActions';
  import DicomViewerButton from './DicomViewerButton';

  export default {
    name: 'CollectionCaseItem',

    components: {
      ThumbnailSvg,
      CollectionItemActions,
      DicomViewerButton,
    },

    props: {
      collectionCase: Object,
      canRemoveCases: Boolean,
      collectionId: Number,
    },

    computed: {
      keyImage() {
        if (!this.collectionCase.keyImages || !this.collectionCase.keyImages.length) {
          return null;
        }
        return this.collectionCase.keyImages[0];
      },

      isMobile() {
        return this.$store.state.breakpoint === 'xs';
      },
      isTablet() {
        return this.$store.state.breakpoint === 'sm';
      },

      uniqueId() {
        return `collection-case-${this.collectionCase.id}`;
      },
    },
    methods: {
      onRemoveCase(item) {
        this.$emit('removeCase', item);
      },
    },
  };
</script>
